export default "__VITE_PUBLIC_ASSET__1dcf5894__"